export const API_SERVER = process.env.REACT_APP_SERVER_API;
export const API_SERVER_P2 = process.env.REACT_APP_SERVER_API_P2;
export const MTTQ_HOST = process.env.REACT_APP_MTTQ_HOST;
export const MTTQ_PORT = process.env.REACT_APP_MTTQ_PORT;
export const MTTQ_CLIENT_ID = process.env.REACT_APP_MTTQ_CLIENT_ID;
export const ACCESS_TOKEN = "_ac_tk";
export const REFRESH_TOKEN = "_rf_tk";
